import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

// 查找案例分类
  findCaseClassById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/findCaseClassById`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
// 案例分类列表
  findCaseClassByList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/findCaseClassByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 保存案例分类
  saveCaseClass({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/saveCaseClass`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findCaseInfoByList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/findCaseInfoByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findCaseInfoByList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/findCaseInfoByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findCaseInfoById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/findCaseInfoById`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveCaseInfo({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/saveCaseInfo`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  delCaseClassTow({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/delCaseClassTow`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findOneClassByList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/findOneClassByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findTowClassByList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/case/findTowClassOne`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },




  




}









